import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { X } from 'lucide-react'

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent')
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setShowBanner(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted')
    setShowBanner(false)
    // Initialize analytics or other tracking here
    console.log('Cookies accepted')
  }

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined')
    setShowBanner(false)
    console.log('Cookies declined')
  }

  const handleClose = () => {
    setShowBanner(false)
    // Will show again on next visit if no choice was made
  }

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 p-3"
        >
          <div className="max-w-5xl mx-auto">
            <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-4 relative">
              {/* Close button */}
              <button
                onClick={handleClose}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
                aria-label="Close"
              >
                <X size={18} />
              </button>

              <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                {/* Cookie icon */}
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center text-xl">
                    🍪
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-base font-bold mb-1">Wir verwenden Cookies</h3>
                  <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-0">
                    Wir verwenden Cookies um deine Erfahrung zu verbessern.{' '}
                    <a href="/privacy" className="text-primary hover:underline font-semibold">
                      Datenschutzerklärung
                    </a>
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-row gap-2 w-full md:w-auto">
                  <button
                    onClick={handleDecline}
                    className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors whitespace-nowrap"
                  >
                    Ablehnen
                  </button>
                  <button
                    onClick={handleAccept}
                    className="px-4 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-opacity whitespace-nowrap"
                  >
                    Akzeptieren
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CookieConsent
